import ErrorDialog from '@/ui/components/ErrorDialog.vue';

// An error that needs more room than a toast, e.g. a list of the items an operation failed on:
// this.$errorModal.open({ title, content, items })
const plugin = (app, globalOptions = {}) => {
  const openErrorModal = function(options) {
    const propsData = Object.assign({}, globalOptions, options);

    // 'this' is the Vue component instance when called as this.$errorModal.open()
    if (!this.$fullscreenModal) {
      // eslint-disable-next-line no-console
      console.error('ErrorModal: $fullscreenModal not available');
      return null;
    }

    return this.$fullscreenModal.open(
      this,
      ErrorDialog,
      propsData,
    );
  };

  Object.defineProperty(app.config.globalProperties, '$errorModal', {
    get() {
      return {
        open: openErrorModal.bind(this),
      };
    },
  });
};

/* eslint-disable-next-line local-rules/custom-naming-pattern */
const ErrorModal = { install: plugin };

export { ErrorModal, ErrorModal as default };
